import { render } from "./homepage.vue?vue&type=template&id=789b8bc0&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"

import "./homepage.vue?vue&type=style&index=0&id=789b8bc0&lang=less&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789b8bc0"]])

export default __exports__